<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 서울시 교육복지사업 ‘서울런’ 참여…검정고시·자격증 최신 강좌 지원</h4>
                            <!-- <div class="board_meta">
                                <ul>
                                    <li>등록일 : 22.05.24</li>
                                    <li>조회수 : 142</li>
                                </ul>
                            </div> -->
                        </div>
                        <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_01.png"></figure>
                                <br>
                                <br>
                                에듀윌이 교육 기회가 부족한 서울 청소년 학습 격차 해소를 위한 지원에 나섰다.
                                <br><br>

                                종합교육기업 에듀윌(대표 박명규)이 서울시 교육복지사업 ‘서울런’에 합류한다고 밝혔다. 금일부터 서울시 교육 플랫폼 ‘서울런’에서는 에듀윌의 검정고시 및
                                자격증 최신 강좌를 수강할 수 있다.
                                <br><br>


                                ‘서울런’은 교육 기회가 부족한 청소년들의 학습 격차 해소와 차별 없는 교육 환경 마련을 위해 추진되는 서울시의 교육복지사업이다. 에듀윌은 이번 사업에 참여해
                                학교 밖 청소년과 다문화가정 청소년 등 학습 자원에 접근하기 어려운 청소년에게 최신 강좌를 제공한다는 방침이다.
                                <br><br>


                                특히 에듀윌이 제공하는 강좌는 검정고시 및 자격증 강좌로 구성되어 청소년들의 진학 및 취업에 큰 도움이 될 전망이다. 에듀윌이 제공하는 강좌는 중졸
                                검정고시(56개)와 고졸 검정고시(65개)를 포함해 검정고시 강좌 총 121개와 위험물기능사, 컴퓨터 활용 및 워드프로세서, 전산세무회계 등 취업에 활용되는
                                전문 자격 강의 총 176개 강좌다.
                                <br><br>


                                에듀윌 관계자는 “학습 기회가 부족한 청소년들이 검정고시 강의를 통해 학업을 이어가고, 자격증과 취업 강의로 자신의 꿈을 위해 한걸음 더 나아갈 수 있도록
                                최선을 다해 지원할 것”이라 말했다.
                                <br><br>


                                에듀윌 검정고시 강의는 ‘서울런’ 회원가입 후 검정고시 카테고리를 선택해 수강 가능하고, 전문 자격증 강의의 경우 ‘서울런’ 회원 모두가 수강 가능하도록
                                구성됐다.
                                <br><br>


                                한편 5년간 아무도 깨지 못한 합격자 수 1위 에듀윌은 세 번의 대통령상 수상을 비롯, 정부기관상 13관왕에 빛나는 종합교육기업이다. 한국리서치 공무원
                                선호도, 인지도 조사 결과 1위에 올랐으며, KRI 한국기록원에 공인중개사 최다 합격자 배출 기록을 세 번 공식 인증받았다.
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news9" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, 국립공주대와 `부동산학과 재학생 교육 지원` 업무 협약 체결</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                                <!-- 다음 보도 기사가 있을 경우 -->
                                <li class="next">
                                   <router-link to="/edu/newsRelease/promotionVideo/news2" data-value="315283">
                                        <strong>다음</strong>
                                        <span>에듀윌, 코로나 시대 공기업 및 대기업 취업 화상교육 진행</span>
                                    </router-link>
                                </li>
                                <!-- //다음 보도 기사가 있을 경우 -->
                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
